// Copyright (c) 2015, Orbit7 Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

if (orbit7.require) {
	orbit7.require("file_uploader.bundle.js");
} else {
	orbit7.ready(function () {
		orbit7.require("file_uploader.bundle.js");
	});
}
